<template>
    <div class="page">
        <div class="gridheader">
            <div class="row wrapper">
                <div class="col-md-2"></div>
                <div class="col-md-8 search-form">
                    <form method="get" action="">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>{{$t('MONTH')}}</label>
                                    <select v-model="params.month" class="form-control secondary">
                                        <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>{{$t('YEAR')}}</label>
                                    <select v-model="params.year" class="form-control secondary">
                                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label>{{$t('COMPANY')}}</label>
                                    <select v-model="params.ordererCompanyId" class="form-control secondary">
                                        <option value="">{{ $t('ALL') }}</option>
                                        <option v-for="company in companies.root" :value="company.companyId" :key="company.companyId">{{ company.companyName }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>{{$t('PRODUCT')}}</label>
                                    <select v-model="params.dentalSolutionTypeId" class="form-control secondary">
                                        <option v-for="ds in dentalsolutiontypes.root" :value="ds.dentalSolutionTypeId" :key="ds.dentalSolutionTypeId">{{ $t(ds.name) }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3 action">
                                <router-link :to="{ path: '/printdsmonthlyreport/', query: getQueryParams }" class="btn btn-white d-none d-md-block"><img src="../assets/img/icon-print.svg" alt=""> {{ $t('PRINT')}}</router-link>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>
        <div class="row reports report-monthly">
            <div class="table-responsive">
                <table class="maintable reports">
                    <thead>
                        <tr v-if="report.root[0]">
                            <td>{{$t('CLIENT')}}</td>
                            <td v-for="(num, date) in report.root[0].quantityPerDate">{{date}}</td>
                            <td>{{$t('TOTAL')}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, i) in report.root" :key="i">
                            <td>{{row.companyName}}</td>
                            <td v-for="(num, date) in row.quantityPerDate">
                                <div class="date" :class="{'empty': (num == 0)}">{{(num == 0) ? '' : num}}<!-- div class="weekend"></div --></div>
                            </td>
                            <td>{{row.num}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td>{{ $t('TOTAL')+':' }}</td>
                            <td>{{report.total}}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapActions,
    mapGetters
}
from 'vuex'
import dentalsolutiontypesApi from '@/api/dentalsolutiontypes'
import dentalsolutionsApi from '@/api/dentalsolutions'
import moment from 'moment';

export default
{
    name: 'ReportsDs',
    data: function()
    {
        return {
            dentalsolutiontypes: {
                root: [],
                totalCount: 0
            },
            companies: {
                root: [],
                totalCount: 0
            },
            report: {
                root: [],
                totalCount: 0,
                total: 0
            },
            params:
            {
                month: moment().format('M'),
                year: moment().format('YYYY'),
                ordererCompanyId: '',
                dentalSolutionTypeId: '',
            }
        };
    },
    created: function()
    {
        var me = this;

        me.getCompanies();
        me.getDentalSolutionTypes();
        me.getMonthlyReport();
    },
    methods:
    {
        getDentalSolutionTypes()
        {
            const me = this;
            dentalsolutiontypesApi.selectRow({}, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.dentalsolutiontypes = Object.assign({}, data);
            });
        },
        getCompanies()
        {
            var me = this;
            dentalsolutionsApi.selectDentalSolutionUsers({}, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.companies = data;
                }
            });
        },
        setCompanyId(val)
        {
            var me = this;
            me.params.companyId = val;
        },
        getMonthlyReport()
        {
            var me = this;
            const params = { ...me.params };

            params.date = moment(params.date).format('YYYY-MM-DD');

            dentalsolutionsApi.getMonthlyReport(params, function(data)
            {
                if (data.error)
                {
                    me.$notify.error(data.notice);
                }
                else
                {
                    me.report = data;
                }
            });
        }
    },
    watch:
    {
        'params.date': function()
        {
            var me = this;
            me.getMonthlyReport();
        },
        'params.ordererCompanyId': function()
        {
            var me = this;
            me.getMonthlyReport();
        },
        'params.dentalSolutionTypeId': function()
        {
            var me = this;
            me.getMonthlyReport();
        },
    },
    computed: {
        ...mapGetters([
            'globals'
        ]),
        years()
        {
            const data = [];

            for(let i=2020;i<2040;i++)
            {
                data.push(i);
            }

            return data;
        },
        months()
        {
            const data = [];

            for(let i=1;i<=12;i++)
            {
                if(String(i).length == 1)
                {
                    data.push('0'+String(i));
                }
                else
                {
                    data.push(String(i));
                }
            }

            return data;
        },
        getQueryParams()
        {
            const me = this;

            return {
                ...me.params,
                date: moment(me.params.date).format('YYYY-MM-DD')            
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportsDsMonthly.vue